<template>
  <el-dropdown @command="handleCommand">
    <div class="page-header-right">
      <img class="user-avatar" :src="userAvatar" />
    </div>
    <el-dropdown-menu style="padding: 4px 0;" slot="dropdown">
      <div class="dropdown-user">
        <div>
          <img class="dropdown-user-img" :src="userAvatar" />
          <div class="dropdown-user-name">{{ userName }}</div>
        </div>
      </div>
      <el-dropdown-item command="handleToInfo" class="flex">
        <i class="el-icon-tickets"></i>
        <div :underline="false" class="dropdown-item">个人资料</div>
      </el-dropdown-item>
      <el-dropdown-item command="handleToAuth" class="flex">
        <i class="el-icon-key"></i>
        <div class="dropdown-item">实名认证</div>
      </el-dropdown-item>
      <el-dropdown-item command="handleToWithdrawal" class="flex">
        <i class="el-icon-suitcase"></i>
        <div class="dropdown-item">提现设置</div>
      </el-dropdown-item>
      <el-dropdown-item command="handleLogout" divided>
        <i class="el-icon-video-pause"></i>退出登录
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["userAvatar", "userName", "authPermissions"])
  },
  methods: {
    handleCommand(command) {
      this[command]();
    },
    handleLogout() {
      this.$store.dispatch("logout");
    },
    handleToInfo() {
      this.$router.push({
        name: "SettingProfileSelf"
      });
    },
    handleToAuth() {
      this.$router.push({
        name: "SettingAuthenticationSelf"
      });
    },
    handleToWithdrawal() {
      this.$router.push({
        name: "SettingWithdrawalSelf"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-header-right {
  padding: 0 20px;
  height: 100%;
  // line-height: 100%;
  transition: all 0.2s ease;
  cursor: pointer;
  // &:hover {
  //   background: #ecf5ff;
  // }
  .user-avatar {
    margin-right: 12px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .user-name {
    margin-right: 12px;
    font-size: 14px;
  }
}
.flex {
  display: flex;
  align-items: center;
}

// /deep/.el-submenu.is-active .el-submenu__title {
//   color: #409eff;
// }
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f0f2f5;
  color: #666666;
  // .dropdown-item {
  //   color: #66b1ff;
  // }
}
.dropdown-user {
  width: 176px;
  height: 132px;
  justify-content: center;
  display: flex;
  align-items: center;

  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 4px;
  .dropdown-user-img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
  .dropdown-user-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin-top: 8px;
  }
}
/deep/.el-dropdown-menu__item--divided:before {
  margin: 0 4px;
  opacity: 0;
  display: none;
}
/deep/.el-dropdown-menu__item {
  margin: 0 4px;
  padding: 0 12px;
  color: #666666;
}

.dropdown-item {
  color: #666666;
}
</style>
